<template>
  <div>
    <label
      v-if="label"
      class="pl-2 label-text"
      >{{ label }}</label
    >
    <v-textarea
      class="rounded-lg mini-text field-edit"
      v-model="dataValue"
      outlined
      dense
      single-line
      no-resize
      :rows="rows"
      :placeholder="placeholder"
      :type="type"
      :disabled="disabled"
      :readonly="readonly"
      :class="errorMessages && errorMessages.length ? 'field-error' : ''"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :hint="hint"
      :persistent-hint="persistentHint"
      @change="change"
      @input="input"
    />
  </div>
</template>

<script>
export default {
  name: 'UITextArea',

  props: {
    label: String,
    value: {
      type: String | Number | null | undefined,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    rows: {
      type: Number,
      default: 3
    },
    errorMessages: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Введите значение'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      default: true
    }
  },

  data: () => {
    return {
      dataValue: null
    }
  },

  methods: {
    change(val) {
      this.$emit('change', val)
    },
    input(val) {
      this.$emit('input', val)
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dataValue = val
      }
    }
  }
}
</script>

<style scoped>
.v-textarea >>> textarea {
  line-height: 1.35rem !important;
}
</style>
